import React, { useState } from 'react';

const CustomSelectField = ({ label, name, value, options, onChange, otherValue, isRequired, klass, isOtherValue}) => {

  return (
    <>
      <div className={`form-group ${klass}`}>
     <label htmlFor={name}>
      {label}
      {isRequired && <span className="mandatory_fields">*</span>}
    </label>
      <select
        className="custom-select"
        id={name}
        name={name}
        value={options.includes(value) ? value : 'Others'}
        required
        onChange={onChange}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
       {isOtherValue &&  <option value="Others">Others</option>}
      </select>
      {!options.includes(value) && isOtherValue  && (
        <input
          type="text"
          className="form-control"
          name={`${name}Other`}
          value={otherValue}
          onChange={onChange}
          placeholder="Specify please"
        />
      )}
    </div>
    </>
   
  );
};

export default CustomSelectField;